import { Component, ChangeDetectionStrategy, EventEmitter, Output, Input, inject } from '@angular/core';
import { SessionService } from '@core/auth/session.service';
import { SidebarComponent } from "./sidebar/sidebar.component";
import { StrHeaderSelectorComponent } from "./str-header-selector/str-header-selector.component";
import { UserMenuComponent } from "./user-menu/user-menu.component";
import { LanguageSelectorComponent } from "./language-selector/language-selector.component";
import { ClockComponent } from './clock/clock.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-header',
  imports: [SidebarComponent, StrHeaderSelectorComponent, UserMenuComponent, LanguageSelectorComponent, ClockComponent, RouterLink],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {
  @Output() menuToggle = new EventEmitter<void>();
  @Input() headerType: string = '';
  @Input() listValue: boolean = false;

  protected readonly session = inject(SessionService);

  onMenuClick(): void {
    this.menuToggle.emit();
  }
}
